import React from "react";
import { useQuiz } from "../context/QuizContext";

export default function Progress() {
  const { index, answer, points, numQuestions, maxPoints } = useQuiz();

  return (
    <div className={"progress"}>
      <progress max={numQuestions} value={index + Number(answer !== null)} />

      <p>
        Question <strong>{index + 1}</strong> / {numQuestions}
      </p>

      <p>
        <strong>{points}</strong> / {maxPoints} Points
      </p>
    </div>
  );
}
